import React from 'react'
import './footer.css'
import {FaFacebook} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {IoLogoTwitter} from 'react-icons/io'
const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>Abílio Aragão</a>

      <ul className="permalinks">
        <li><a href="#">Início</a></li>
        <li><a href="#about">Sobre</a></li>
        <li><a href="#experience">Experiência</a></li>
        <li><a href="#services">Serviços</a></li>
        <li><a href="#portfolio">Projetos</a></li>
        <li><a href="#testimonials">Testemunhos</a></li>
        <li><a href="#contact">Contatos</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://facebook.com/abilio_aragao"><FaFacebook/></a>
        <a href="https://instagram.com/abilio_aragao"><FiInstagram/></a>
        <a href="https://twitter.com/abilio_aragao"><IoLogoTwitter/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Abílio Aragão. All rights reseved</small>
      </div>
    </footer>
  )
}

export default Footer